/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />

namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class ServiceInwardDetailsDialog extends _Ext.EditorDialogBase<ServiceInwardDetailsRow> {
        protected getFormKey() { return ServiceInwardDetailsForm.formKey; }
        protected getLocalTextPrefix() { return ServiceInwardDetailsRow.localTextPrefix; }
        protected getDeletePermission() { return ServiceInwardDetailsRow.deletePermission; }
        protected getInsertPermission() { return ServiceInwardDetailsRow.insertPermission; }
        protected getUpdatePermission() { return ServiceInwardDetailsRow.updatePermission; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        protected form = new ServiceInwardDetailsForm(this.idPrefix);
        
    }
}